module.exports = __webpack_public_path__ + "img/zhzf-bg.f449dbbd.png";